import NavBar from "./navbar/NavBar";
import Hero from "./hero/Hero";
import Main from "./main/Main";
import Footer from "./footer/Footer";
function App() {
  return (
    <div className="App">
      <NavBar/>
      <Hero/>
      <Main/>
      <Footer/>
    </div>
  );
}

export default App;
